import React from 'react';
import type { StructureCursorPresence } from '../../utils/proposalStructurePresenceService';
import './ProposalStructurePresenceLayer.css';

interface ProposalStructurePresenceLayerProps {
  cursors: StructureCursorPresence[];
}

const ProposalStructurePresenceLayer: React.FC<ProposalStructurePresenceLayerProps> = ({
  cursors,
}) => {
  if (cursors.length === 0) return null;

  return (
    <div className="structure-presence-layer" aria-hidden>
      {cursors.map(c => (
        <div
          key={c.uid}
          className="structure-presence-cursor"
          style={{ left: `${c.x}%`, top: `${c.y}%` }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" className="structure-presence-arrow">
            <path
              d="M5.5 3.2L19 11.4l-6.3 1.5-3.2 5.8z"
              fill={c.color}
              stroke="#fff"
              strokeWidth="1.4"
            />
          </svg>
          <span className="structure-presence-name" style={{ background: c.color }}>
            {c.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export function ProposalStructurePresenceBadges({
  cursors,
}: {
  cursors: StructureCursorPresence[];
}) {
  if (cursors.length === 0) return null;
  return (
    <div className="structure-presence-badges" aria-label="Other people viewing this structure">
      {cursors.map(c => (
        <span key={c.uid} className="structure-presence-badge" style={{ background: c.color }}>
          {c.name}
        </span>
      ))}
    </div>
  );
}

export default React.memo(ProposalStructurePresenceLayer);
